import { Card } from '@/components/sections/Card';
import SortButtons from '@/components/sort/SortButtons';
import { SortDirection } from '@/components/table/sortHelper';
import { FunctionComponent, useState } from 'react';

export interface PurchaseOrderLandingPageFilterOptions {
  dateCreated?: SortDirection;
  dateSubmitted?: SortDirection;
  dateUpdated?: SortDirection;
}

enum SortOptions {
  dateCreated,
  dateSubmitted,
  dateUpdated
}

interface PurchaseOrderLandingPageFiltersProps {
  onSortCallback: (sortOptions: PurchaseOrderLandingPageFilterOptions) => void;
}

const PurchaseOrderLandingPageFilters: FunctionComponent<PurchaseOrderLandingPageFiltersProps> = ({
  onSortCallback
}) => {
  const [activeSort, setActiveSort] = useState<SortOptions>();

  return (
    <Card className="flex space-x-3 divide-x shadow-sm border-primary-std ">
      <div className="flex space-x-2 w-fit p-3">
        <p>Date Created</p>
        <SortButtons
          onSortCallback={(sortDirection: SortDirection) => {
            onSortCallback({
              dateCreated: sortDirection
            });
            setActiveSort(SortOptions.dateCreated);
          }}
          isActiveCallback={() => activeSort === SortOptions.dateCreated}
        />
      </div>
      <div className="flex space-x-2 w-fit p-3">
        <p>Date Submitted</p>
        <SortButtons
          onSortCallback={(sortDirection: SortDirection) => {
            onSortCallback({
              dateSubmitted: sortDirection
            });
            setActiveSort(SortOptions.dateSubmitted);
          }}
          isActiveCallback={() => activeSort === SortOptions.dateSubmitted}
        />
      </div>
      <div className="flex space-x-2 w-fit p-3">
        <p>Date Updated</p>
        <SortButtons
          onSortCallback={(sortDirection: SortDirection) => {
            onSortCallback({
              dateUpdated: sortDirection
            });
            setActiveSort(SortOptions.dateUpdated);
          }}
          isActiveCallback={() => activeSort === SortOptions.dateUpdated}
        />
      </div>
    </Card>
  );
};

export default PurchaseOrderLandingPageFilters;
